import React from 'react';
import { getOTGroup, getSBGroup, getWorkLocations, getClassifications, getDutyAssignmentList, getStationTime, getClassificationsByDpt, getDutyAssignmentListByDpt } from '../../constants/constants';
import mandoApi from '../../config/MandoAxiosConfig';
import moment from 'moment';

export const getGroupOptions = async(stationCodes, groupCode) => {
    const response = await mandoApi('GET', groupCode == 'SB Group' ? getSBGroup(stationCodes) : getOTGroup(stationCodes));
    if(response?.status !== 200){
        const errorCode = response?.response?.status;
        const message = 'Error while Fetching OT/SB Group. Please try again later'
    //  setShowModal(true);
    //  setErrorMsg({errorCode,message});
    }
    return groupCode == 'SB Group' ? response.data.sbgroups : response.data.otgroups
}

export const getWorkLocOptions = async (station) => {
    const response = await mandoApi('GET', getWorkLocations(station));
    if (response?.status === 200){
      return response.data["workLocations"];
    }
};

export const getClassificationOptions = async (station,dpt) => {
    let response = null;
    if(dpt!= undefined && dpt !=null){
        response = await mandoApi('GET', getClassificationsByDpt(station,dpt));
    }else{
        response = await mandoApi('GET', getClassifications(station));
    }
    if (response?.status === 200){
      return response.data["classifications"];
    }
}


export const getDutyAssignmentOptions = async (station,dpt) => {
    let response = null;
    if(dpt!= undefined && dpt !=null){
        response = await mandoApi('GET', getDutyAssignmentListByDpt(station,dpt));
    }else{
        response = await mandoApi('GET', getDutyAssignmentList(station)); 
    }
    if (response?.status === 200){
      return response.data["dutyAssignments"];
    }
}

export const getStationTimestamp = async (station) => {
    const response = await mandoApi('GET', getStationTime(station));
    if (response?.status === 200){
    const parsedStationTime = moment.parseZone(response.data);
        if (parsedStationTime.isValid()) {
            return parsedStationTime.format("MM/DD/YYYY HH:mm");
        }
        return moment(response.data).format("MM/DD/YYYY HH:mm");
    }
}

export const getHourArray = (maxTime, minTime, title) => {
        let hourArray = [];
        let startTimeOpts = maxTime == undefined ? 0 : maxTime;
        for (let i=startTimeOpts; i<= (minTime? minTime : 23); i++ ) {
            let iString = i.toString();
            if (iString.length == 1) {
                hourArray.push("0"+iString);
            } else {
                hourArray.push(iString);
            }
        }
        return hourArray;
    }

export const getMinArray = (maxTime, minTime, step) => {
        let minArray = [];
        let startTimeOpts = maxTime == undefined ? 0 :  maxTime == 0?  0 : maxTime + 1;
        let inc = step == undefined ? 1 : step;
        for (let i=startTimeOpts; i<= (minTime !== undefined? minTime : 59); i+=inc ) {
            let iString = i.toString();
            if (iString.length == 1) {
                minArray.push("0"+iString);
            } else {
                minArray.push(iString);
            }
        }
        return minArray;
}

export const isLocationUnavailable = (location = "") => {
    const normalizedLocation = String(location).trim().toLowerCase();
    return !normalizedLocation || normalizedLocation === "not available";
}

export const hasValidLocation = (location = "") => {
    return !isLocationUnavailable(location);
}

export const getDisplayLocation = (location = "") => {
    return isLocationUnavailable(location) ? "Not available" : location;
}

export const handlePreviousPage = (currentPage, totalPages) => {
    let newPage = currentPage;
    if (currentPage > 1) {
        newPage = currentPage- 1;
    }
    return newPage
}

export const handleNextPage = (currentPage, totalPages) => {
    let newPage = currentPage;
    if (currentPage < totalPages) {
        newPage =currentPage+ 1;
    }
    return newPage
    }

export const handleLastPage = (currentPage, totalPages) => {
    let newPage = currentPage;
    if (currentPage < totalPages) {
        newPage = totalPages; 
    }
    return newPage
}

export const handleFirstPage = (currentPage) => {
    let newPage = currentPage;
        if (currentPage > 1) {
            newPage = 1; 
        }
        return newPage
}

// export const handleItemPerPage = (value) => {
//         setItemsperPage(value);
//         setCurrentPage(1);
//         props.getOffersBatch({...dataRequest, size: value})
//       }

// VTO Offer Helper Functions
export const validateOfferTimes = (offersOrHour, minOrOffer, date, stationTime) => {
    if (typeof offersOrHour === 'object' && !Array.isArray(offersOrHour)) {
        const offers = offersOrHour;
        const selectedDate = minOrOffer;
        const now = moment(stationTime, "MM/DD/YYYY HH:mm");
        const minStartTime = moment(now).add(30, 'minutes');
        let errorOfferId = null;
        let updatedOffers = { ...offers };
        
        Object.values(updatedOffers).forEach(offer => {
            if (offer.offerStartTimeHr && offer.offerStartTimeMin) {
                const startTime = moment(`${selectedDate} ${offer.offerStartTimeHr}:${offer.offerStartTimeMin}`, "MM/DD/YYYY HH:mm");
                if (selectedDate === moment(stationTime).format("MM/DD/YYYY")) {
                    if (startTime.isBefore(now)) {
                        offer.error = "Start time has already passed for today.";
                        errorOfferId = offer.id;
                    } else if (startTime.isBefore(minStartTime)) {
                        offer.error = "Start time should be at least 30 minutes from now.";
                        errorOfferId = offer.id;
                    } else {
                        offer.error = false;
                    }
                } else {
                    offer.error = false;
                }
            }
        });
        
        return { updatedOffers, errorOfferId };
    } else {
        const hour = offersOrHour;
        const min = minOrOffer;
        const selectedDate = date;
        const now = stationTime;
        const minStartTime = moment(now).add(30, 'minutes');
        const startTime = moment(`${selectedDate} ${hour}:${min}`, "MM/DD/YYYY HH:mm");
        let error = false;
        let errorMessage = "";
        
        if (selectedDate === moment(stationTime).format("MM/DD/YYYY")) {
            if (startTime.isBefore(now)) {
                error = true;
                errorMessage = "Start time has already passed for today.";
            } else if (startTime.isBefore(minStartTime)) {
                error = true;
                errorMessage = "Start time should be at least 30 minutes from now.";
            }
        }
        
        return { error, errorMessage };
    }
};

export const createHourArray = (startHr, endHr) => {
        const hours = [];
        
        // Handle normal case (start < end)
        if (startHr <= endHr) {
            for (let i = startHr; i <= endHr; i++) {
                // Format with leading zero if needed
                const formattedHour = i.toString().padStart(2, '0');
                hours.push(formattedHour);
            }
        } 
        // Handle overnight shifts (start > end, like 22 to 06)
        else {
            // From start hour to 23
            for (let i = startHr; i <= 23; i++) {
                hours.push(i.toString().padStart(2, '0'));
            }
            // From 00 to end hour
            for (let i = 0; i <= endHr; i++) {
                hours.push(i.toString().padStart(2, '0'));
            }
        }
        
        return hours;
    };

export const updateAllOfferErrors = (offers, selectedDates, stationTime) => {
    const todaySelected = selectedDates.includes(moment(stationTime).format("MM/DD/YYYY"));
    let updated = { ...offers };
    
    Object.values(updated).forEach(offer => {
        if (offer.offerStartTimeHr && offer.offerStartTimeMin) {
            const startTime = moment(`${moment(stationTime).format("MM/DD/YYYY")} ${offer.offerStartTimeHr}:${offer.offerStartTimeMin}`, "MM/DD/YYYY HH:mm");
            if (todaySelected) {
                const now = moment(stationTime, "MM/DD/YYYY HH:mm");
                const minStartTime = moment(now).add(30, 'minutes');
                if (startTime.isBefore(now)) {
                    offer.error = "Start time has already passed for today.";
                } else if (startTime.isBefore(minStartTime)) {
                    offer.error = "Start time should be at least 30 minutes from now.";
                } else {
                    offer.error = false;
                }
            } else {
                offer.error = false;
            }
        } else {
            offer.error = "Select Start Time/End Time";
        }
    });
    
    return updated;
};

export const setCutOffTime = (dateSelected, stationTime) => {
    let cutOffTime = {};
    const now = moment(stationTime);
    const sixPm = moment(stationTime).set({ hour: 18, minute: 0, second: 0, millisecond: 0 });
    const isToday = moment(dateSelected).format("MM/DD/YYYY") === moment(stationTime).format("MM/DD/YYYY");
    // const isYesterday = date === moment().subtract(1, "days").format("MM/DD/YYYY");
    const isAfterSixPm = now.isAfter(sixPm);

    if (isToday || isAfterSixPm) {
        cutOffTime = {
            time: "",
            date: moment(dateSelected).format("MM/DD/YYYY"),
            default: "",
            untilDepleted: true
        };
    } else {
        cutOffTime = {
            time: "18:00",
            date: moment(dateSelected).subtract(1, "days").format("MM/DD/YYYY"),
            default: `${moment().format("MM/DD/YYYY")} 18:00`,
            untilDepleted: false
        };
    }
    
    return cutOffTime;
};

export const setCutOffTimeEmp = (dateSelected, stationTime, stationCutoffTime) => {
    let cutOffTime = {};
      const selectedDateStr = moment(dateSelected).format("MM/DD/YYYY");
    const stationDateStr = moment(stationTime).format("MM/DD/YYYY");
    // Build a full datetime from the selected date and cutoff time, then subtract 30 minutes.
    // This ensures that cutoffs that cross midnight (e.g., 00:15 - 30 mins = 23:45 previous day)
    // have the correct cutoff date as well as time.
    const baseDateTime = moment(`${selectedDateStr} ${stationCutoffTime}`, "MM/DD/YYYY HH:mm");
    if (baseDateTime.isValid()) {
        const cutoffDateTime = baseDateTime.clone().subtract(30, "minutes");
        const cutoffDateStr = cutoffDateTime.format("MM/DD/YYYY");
        const cutoffTimeStr = cutoffDateTime.format("HH:mm");
        const isToday = cutoffDateStr === stationDateStr;
        cutOffTime = {
            time: cutoffTimeStr,
            date: cutoffDateStr,
            default: `${cutoffDateStr} ${cutoffTimeStr}`,
            untilDepleted: isToday
        };
    } else {
        // Fallback to previous behavior if the datetime cannot be parsed.
        const isToday = selectedDateStr === stationDateStr;
        cutOffTime = {
            time: stationCutoffTime,
            date: selectedDateStr,
            default: `${selectedDateStr} ${stationCutoffTime}`,
            untilDepleted: isToday
        };
    }
    
    return cutOffTime;
};
export const buildOffersResponse = (offersToProcess, selectedDates, selectedStation, selectedDepartment, selectedWorkLoc, selectedClassification, selectedDutyAssig, datesToUse = null) => {
    let counter = 0;
    const response = {
        "isAdmin":true,
        "station": selectedStation,
        "department": selectedDepartment,
        "workLocation": selectedWorkLoc,
        "offers": []
    };

    const processOffers = (offers, dates) => {
        offers.forEach(offer => {
            const targetDates = dates || selectedDates;
            
            targetDates.forEach(date => {
                if (!offer.cutOffTime || !offer.cutOffTime[date]) return;
                
                let existingDateOffer = response.offers.find(dateOffer => dateOffer.date === date);
                if (!existingDateOffer) {
                    existingDateOffer = {
                        date: date,
                        shifts: []
                    };
                    response.offers.push(existingDateOffer);
                }
                
                let shiftDetails = {
                    "id": counter,
                    "startTime": `${offer.offerStartTimeHr}:${offer.offerStartTimeMin}`,
                    "endTime": `${offer.offerEndTimeHr}:${offer.offerEndTimeMin}`,
                    "slots": offer.slots,
                    "duration": offer.duration,
                    "cutOffTime": `${offer.cutOffTime[date].date} ${offer.cutOffTime[date].time}`,
                    "default": offer.cutOffTime[date].default,
                    "untilDepleted": offer.cutOffTime[date].untilDepleted,
                    "dutyAssignment": offer.dutyAssignment || selectedDutyAssig,
                    "classification": offer.classification || selectedClassification,
                    "note": offer?.note || ""
                };
                counter++;
                
                existingDateOffer.shifts.push(shiftDetails);
            });
        });
    };

    if (Array.isArray(offersToProcess)) {
        offersToProcess.forEach(offerToCreate => {
            const targetDates = offerToCreate.datesToCreate || datesToUse || selectedDates;
            processOffers([offerToCreate], targetDates);
        });
    } else {
        processOffers(Object.values(offersToProcess));
    }
    
    response.offers = response.offers.filter(offer => offer.shifts.length > 0);
    return response;
};

export const createSearchCriteria = (dateShown, selectedStation, selectedClassification, selectedDutyAssig, isCheckedApplyAll) => {
    const searchCriteria = [
        {
            "queryOperator": "IN",
            "searchField": "offerDate",
            "value": "",
            "values": [dateShown]
        },
        {
            "queryOperator": "EQUALS",
            "searchField": "station",
            "value": selectedStation
        }
    ];

    if (selectedClassification && isCheckedApplyAll) {
        searchCriteria.push({
            "queryOperator": "EQUALS",
            "searchField": "classification",
            "value": selectedClassification
        });
    }

    if (selectedDutyAssig && isCheckedApplyAll) {
        searchCriteria.push({
            "queryOperator": "EQUALS",
            "searchField": "dutyAssignment",
            "value": selectedDutyAssig
        });
    }

    return searchCriteria;
};

export const isAfter2330 = (stationTime) => {
    if (!stationTime) return false;
    const stationTimeClean = typeof stationTime === 'string' ? stationTime.split('.')[0] : stationTime;
    const stationMoment = moment(stationTimeClean);
    const hour = stationMoment.hour();
    const minute = stationMoment.minute();
    return hour > 23 || (hour === 23 && minute >= 30);
};

export const validateFields = (selectedDepartment, selectedDates, selectedStation, selectedClassification, selectedDutyAssig, isCheckedApplyAll) => {
    const isRequiredFieldsSelected = !!selectedDepartment && selectedDates.length > 0 && !!selectedStation;
    const isClassificationAndDutyValid = isCheckedApplyAll 
        ? selectedClassification && selectedDutyAssig 
        : true;

    return {
        isValid: isRequiredFieldsSelected && isClassificationAndDutyValid,
        isRequiredFieldsSelected,
        isClassificationAndDutyValid,
    };
};

